export const MessageTypeTitle = {
    accessDenegate : 'Acceso denegado',
    processOk : "Operación realizada correctamente",
    Error: 'Error'
}

export const MessageTypeBody = {
    accessDenegate : "Usuario no encontrado en el sistema.",
    paymentInProcess : "El pago se encuentra en proceso.",
    conectionError: "Error de conexión con el servicio. Por favor intente más tarde.",
    processError: "No se pudo procesar el pago. Por favor intente más tarde.",
    completeData: "Por favor ingrese todos los datos.",
    validateMail: "Por favor ingrese una dirección de correo electrónico válida",
    validateConfirmMail: "Debe confirmar el correo electrónico"
}

export const NotificationType = {
    INFO : 'info',    
    DANGER : 'danger',
    WARNING : 'warning',
    SUCCESS : 'success',
    DEFAULT : 'default',
}

export const NotificationContainerType = {
    TOPLEFT : 'top-left',
    TOPRIGHT : 'top-right',
    TOPCENTER : 'top-center',
    BOTTOMLEFT : 'bottom-left',
    BOTTOMRIGHT : 'bottom-right',
    BOTTOMCENTER : 'bottom-center'
}